export const ACTIONS_ELECTION_RESULT = {
	ELECTION_RESULT: 'election_result',
	ELECTION_RESULT_VIEW: 'election_result_view',
} as const;
